import { render, staticRenderFns } from "./search.vue?vue&type=template&id=474672dc&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474672dc')) {
      api.createRecord('474672dc', component.options)
    } else {
      api.reload('474672dc', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=474672dc&", function () {
      api.rerender('474672dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/orders/partials/search.vue"
export default component.exports